module.exports = __webpack_public_path__ + "img/29.2e7abc5b.jpg";